<div class="hidden-md hidden-lg">
  <app-nav></app-nav>
</div>
<div class="visible-lg visible-md">
  <app-headermain></app-headermain>
</div>

<main class="pay-page">
  <div class="pay-container">

    <!-- Steps -->
    <ol class="pay-steps" aria-label="Booking progress">
      <li class="pay-step pay-step--done"><span class="pay-step__dot"><i class="fas fa-check" aria-hidden="true"></i></span><span class="pay-step__label">Select flight</span></li>
      <li class="pay-step pay-step--current" aria-current="step"><span class="pay-step__dot">2</span><span class="pay-step__label">Traveller details &amp; payment</span></li>
      <li class="pay-step"><span class="pay-step__dot">3</span><span class="pay-step__label">Confirmation</span></li>
    </ol>

    <div class="pay-layout">
      <div class="pay-main">

        <!-- Trip -->
        <section class="pay-card pay-trip" aria-label="Your trip">
          <header class="pay-card__head">
            <div>
              <h2 class="pay-card__title">Your trip</h2>
              <p class="pay-card__sub">
                {{ bookingData.slices.length > 1 ? 'Round trip' : 'One way' }}
                &middot; {{ travellerSummary }}
                &middot; Economy
              </p>
            </div>
          </header>

          @for (seg of bookingData.slices; track seg; let si = $index) {
            <div class="pay-leg">
              <div class="pay-leg__airline">
                <img
                  class="pay-leg__logo"
                  [src]="carrierLogoService.getCarrierLogo(seg.segments[0].marketing_carrier)"
                  [alt]="seg.segments[0].marketing_carrier.name || 'Airline logo'"
                  (error)="carrierLogoService.setLogoPlaceholder($event)">
                <div class="pay-leg__airline-text">
                  @if (bookingData.slices.length > 1) {
                    <span class="pay-tag">{{ si === 1 ? 'Return' : 'Onward' }}</span>
                  }
                  <span class="pay-leg__name">{{ seg.segments[0].marketing_carrier.name }}</span>
                  <span class="pay-leg__number">{{ seg.segments[0].marketing_carrier.iata_code }} {{ seg.segments[0].marketing_carrier.flight_number }}</span>
                </div>
              </div>
              <div class="pay-leg__point">
                <span class="pay-leg__time">{{ seg.segments[0].departing_at.split("T")[1] | timeFormart }}</span>
                <span class="pay-leg__place"><b>{{ seg.origin.iata_code }}</b> &middot; {{ seg.segments[0].departing_at.split("T")[0] | date:'EEE, d MMM' }}</span>
              </div>
              <div class="pay-leg__path">
                <span class="pay-leg__line" aria-hidden="true"><i class="fas fa-plane"></i></span>
                <span class="pay-leg__stops" [class.pay-leg__stops--direct]="seg.segments.length <= 1">
                  {{ seg.segments.length <= 1 ? 'Non-stop' : (seg.segments.length - 1) + (seg.segments.length === 2 ? ' stop' : ' stops') }}
                </span>
              </div>
              <div class="pay-leg__point pay-leg__point--arrive">
                <span class="pay-leg__time">{{ seg.segments[seg.segments.length - 1].arriving_at.split("T")[1] | timeFormart }}</span>
                <span class="pay-leg__place"><b>{{ seg.destination.iata_code }}</b> &middot; {{ seg.segments[seg.segments.length - 1].arriving_at.split("T")[0] | date:'EEE, d MMM' }}</span>
              </div>
            </div>
          }

          <div class="pay-trip__foot">
            <button
              type="button"
              class="pay-link"
              aria-controls="FlightPaymentDetails"
              [attr.aria-expanded]="showTripDetails"
              (click)="showTripDetails = !showTripDetails">
              {{ showTripDetails ? 'Hide flight details' : 'Flight details' }}
              <i class="fas fa-chevron-down" aria-hidden="true"></i>
            </button>
          </div>

          @if (showTripDetails) {
            <div class="pay-details" id="FlightPaymentDetails">
              @for (seg of bookingData.slices; track seg; let si = $index) {
                <div class="pay-details__slice">
                  @for (segment of seg.segments; track segment) {
                    <div class="pay-segment">
                      <div class="pay-segment__carrier">
                        <img class="pay-segment__logo" [src]="carrierLogoService.getCarrierLogo(segment.marketing_carrier)" [alt]="segment.marketing_carrier.name || 'Airline logo'" (error)="carrierLogoService.setLogoPlaceholder($event)">
                        @if (bookingData.slices.length > 1) {
                          <span class="pay-tag">{{ si === 1 ? 'Return' : 'Onward' }}</span>
                        }
                        <span class="pay-segment__name">{{ segment.marketing_carrier.name }}</span>
                        <span class="pay-segment__number">{{ segment.marketing_carrier.iata_code }} {{ segment.marketing_carrier.flight_number }}</span>
                      </div>
                      <div class="pay-segment__grid">
                        <ol class="pay-stops">
                          <li class="pay-stop">
                            <span class="pay-stop__time">{{ segment.departing_at.split("T")[1] | timeFormart }}</span>
                            <span class="pay-stop__dot" aria-hidden="true"></span>
                            <span class="pay-stop__text">
                              <b>{{ segment.origin.name }}</b>
                              <span>{{ segment.departing_at.split("T")[0] | date:'EEE, d MMM y' }} &middot; {{ segment.origin.city_name }}</span>
                            </span>
                          </li>
                          <li class="pay-stop pay-stop--gap">
                            <span class="pay-stop__time"></span>
                            <span class="pay-stop__dot pay-stop__dot--none" aria-hidden="true"></span>
                            <span class="pay-stop__duration"><i class="far fa-clock" aria-hidden="true"></i> {{ segment.duration | duration }}</span>
                          </li>
                          <li class="pay-stop">
                            <span class="pay-stop__time">{{ segment.arriving_at.split("T")[1] | timeFormart }}</span>
                            <span class="pay-stop__dot" aria-hidden="true"></span>
                            <span class="pay-stop__text">
                              <b>{{ segment.destination.name }}</b>
                              <span>{{ segment.arriving_at.split("T")[0] | date:'EEE, d MMM y' }} &middot; {{ segment.destination.city_name }}</span>
                            </span>
                          </li>
                        </ol>
                        @if (segment?.passengers?.[0]?.baggages?.length) {
                          <div class="pay-bags">
                            <span class="pay-bags__title">Baggage per traveller</span>
                            @for (bg of segment.passengers[0].baggages; track bg) {
                              @if (bg.type == 'carry_on') {
                                <span class="pay-bag" [class.pay-bag--off]="!(bg.quantity > 0)">
                                  <i class="fas fa-suitcase" aria-hidden="true"></i>
                                  Cabin bag: {{ bg.quantity > 0 ? bg.quantity + (bg.quantity > 1 ? ' pieces' : ' piece') : 'not included' }}
                                </span>
                              }
                              @if (bg.type == 'checked') {
                                <span class="pay-bag" [class.pay-bag--off]="!(bg.quantity > 0)">
                                  <i class="fas fa-suitcase-rolling" aria-hidden="true"></i>
                                  Checked bag: {{ bg.quantity > 0 ? bg.quantity + (bg.quantity > 1 ? ' pieces' : ' piece') : 'not included' }}
                                </span>
                              }
                            }
                          </div>
                        }
                      </div>
                      @if (segment.waiting != 0) {
                        <div class="pay-layover">
                          <i class="fas fa-exchange-alt" aria-hidden="true"></i>
                          <span>
                            Change planes in {{ segment.destination.city_name }} ({{ segment.destination.iata_code }})
                            &middot; <b>{{ segment.waiting }}</b> layover
                            <a href="https://www.iatatravelcentre.com/passport-visa-health-travel-document-requirements.htm" target="_blank" rel="noopener noreferrer">Check transit visa requirements</a>
                          </span>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </section>

        @if (isError) {
          <div class="pay-alert" role="alert">
            <span class="pay-alert__icon" aria-hidden="true"><i class="fas fa-exclamation"></i></span>
            <div>
              <b>We couldn't process your payment.</b>
              <ul>
                <li>Double-check your mobile number.</li>
                <li>Make sure you have enough money in your M-Pesa.</li>
                <li>Try again in a moment.</li>
              </ul>
            </div>
          </div>
        }

        <form id="ngFormPayment" class="pay-form" [class.pay-form--multi]="passengerForms.length > 1" [formGroup]="paymentForm" novalidate>

          @if (remainingMissingFields > 0) {
            <div class="pay-alert pay-alert--fields" role="alert">
              <span class="pay-alert__icon" aria-hidden="true"><i class="fas fa-exclamation"></i></span>
              <div>
                <b>{{ remainingMissingFields }} {{ remainingMissingFields === 1 ? 'field needs' : 'fields need' }} your attention.</b>
                <span class="pay-alert__text">Fill in the highlighted fields below, then press Pay now.</span>
              </div>
            </div>
          }

          <!-- Travellers -->
          @if (passengerForms.length > 1) {
            <div class="pay-progress" aria-live="polite">
              <div class="pay-progress__text">
                <b>Traveller details</b>
                <span>{{ completedTravellers }} of {{ passengerForms.length }} complete</span>
              </div>
              <div class="pay-progress__dots">
                @for (p of passengerForms; track p.key) {
                  <button
                    type="button"
                    class="pay-progress__dot"
                    [class.pay-progress__dot--done]="isTravellerComplete(p)"
                    [class.pay-progress__dot--current]="isTravellerOpen(p)"
                    [attr.aria-label]="p.label + (isTravellerComplete(p) ? ', complete' : ', incomplete')"
                    (click)="openTravellerCard(p)">
                    @if (isTravellerComplete(p)) {
                      <i class="fas fa-check" aria-hidden="true"></i>
                    } @else {
                      {{ p.position }}
                    }
                  </button>
                }
              </div>
            </div>
          }

          @for (p of passengerForms; track p.key) {
            <section
              class="pay-card pay-traveller"
              [class.pay-traveller--closed]="!isTravellerOpen(p)"
              [class.pay-traveller--done]="isTravellerComplete(p)"
              [class.pay-traveller--error]="!isTravellerOpen(p) && travellerHasErrors(p)"
              [attr.id]="'traveller-' + p.id"
              [attr.aria-label]="p.label">
              <header class="pay-card__head pay-traveller__head" (click)="!isTravellerOpen(p) && openTravellerCard(p)">
                <div class="pay-traveller__heading">
                  <h2 class="pay-card__title">
                    <span class="pay-card__num" [class.pay-card__num--done]="isTravellerComplete(p)">
                      @if (isTravellerComplete(p)) {
                        <i class="fas fa-check" aria-hidden="true"></i>
                      } @else {
                        {{ p.position }}
                      }
                    </span>
                    {{ p.label }}
                    @if (p.primary) {
                      <span class="pay-badge"><i class="fas fa-user-check" aria-hidden="true"></i> Primary (payee)</span>
                    }
                  </h2>
                  @if (isTravellerOpen(p)) {
                    <p class="pay-card__sub">{{ p.hint }} &middot; Enter names exactly as on the passport or ID.</p>
                  } @else if (isTravellerComplete(p)) {
                    <p class="pay-card__sub pay-traveller__summary">{{ travellerLine(p) }}</p>
                  } @else if (travellerHasErrors(p)) {
                    <p class="pay-card__sub pay-traveller__summary pay-traveller__summary--error">Some details are missing or invalid.</p>
                  } @else {
                    <p class="pay-card__sub">{{ p.hint }} &middot; Details needed</p>
                  }
                </div>
                @if (!isTravellerOpen(p)) {
                  <button type="button" class="pay-link" (click)="$event.stopPropagation(); openTravellerCard(p)">
                    {{ isTravellerComplete(p) ? 'Edit' : 'Add details' }}
                    <i class="fas fa-chevron-down" aria-hidden="true"></i>
                  </button>
                }
              </header>

              @if (isTravellerOpen(p)) {

              @if (p.primary && paymentPrefilledFromAccount) {
                <div class="pay-note">
                  <i class="fas fa-info-circle" aria-hidden="true"></i>
                  <span>We prefilled these details from your account. You can edit them if you are booking for someone else.</span>
                </div>
              }

              <div class="pay-grid">
                @if (p.s === 'a') {
                  <div class="pay-field pay-field--title" [class.pay-field--error]="hasError('title' + p.id)">
                    <label class="pay-field__label" [attr.for]="'title' + p.id">Title</label>
                    <div class="pay-select">
                      <select class="pay-input" [id]="'title' + p.id" [attr.name]="'title' + p.id" [formControlName]="'title' + p.id">
                        <option value="">Select title</option>
                        <option value="mr">Mr</option>
                        <option value="ms">Miss</option>
                        <option value="mrs">Mrs</option>
                      </select>
                      <i class="fas fa-chevron-down" aria-hidden="true"></i>
                    </div>
                    @if (showError('title' + p.id, 'required')) { <small class="pay-field__error">Select a title.</small> }
                  </div>
                  <div class="pay-grid__break" aria-hidden="true"></div>
                }

                <div class="pay-field" [class.pay-field--error]="hasError('fname' + p.id)">
                  <label class="pay-field__label" [attr.for]="'fname' + p.id">First name</label>
                  <input class="pay-input" type="text" autocomplete="given-name" placeholder="As on passport or ID"
                    [id]="'fname' + p.id" [attr.name]="'fname' + p.id" [formControlName]="'fname' + p.id">
                  @if (showError('fname' + p.id, 'pattern')) { <small class="pay-field__error">Use letters only, without numbers or spaces.</small> }
                  @if (showError('fname' + p.id, 'required')) { <small class="pay-field__error">First name is required.</small> }
                </div>

                <div class="pay-field" [class.pay-field--error]="hasError('lname' + p.id)">
                  <label class="pay-field__label" [attr.for]="'lname' + p.id">Last name</label>
                  <input class="pay-input" type="text" autocomplete="family-name" placeholder="As on passport or ID"
                    [id]="'lname' + p.id" [attr.name]="'lname' + p.id" [formControlName]="'lname' + p.id">
                  @if (showError('lname' + p.id, 'pattern')) { <small class="pay-field__error">Use letters only, without numbers or spaces.</small> }
                  @if (showError('lname' + p.id, 'required')) { <small class="pay-field__error">Last name is required.</small> }
                </div>

                @if (p.s === 'a') {
                  <div class="pay-field" [class.pay-field--error]="hasError('idno' + p.id)">
                    <label class="pay-field__label" [attr.for]="'idno' + p.id">Passport or ID number</label>
                    <input class="pay-input" type="text" placeholder="Passport / National ID"
                      [id]="'idno' + p.id" [attr.name]="'idno' + p.id" [formControlName]="'idno' + p.id">
                    @if (showError('idno' + p.id, 'minlength')) { <small class="pay-field__error">Enter a valid passport or ID number.</small> }
                    @if (showError('idno' + p.id, 'required')) { <small class="pay-field__error">Passport or ID number is required.</small> }
                  </div>
                }

                <div class="pay-field" [class.pay-field--error]="hasError('country' + p.id)">
                  <label class="pay-field__label" [attr.for]="'country' + p.id">Nationality</label>
                  <div class="pay-select">
                    <select class="pay-input" [id]="'country' + p.id" [attr.name]="'country' + p.id" [formControlName]="'country' + p.id">
                      <option value="">Select nationality</option>
                      @for (country of nationalityOptions; track country.code) {
                        <option [value]="country.code">{{ country.name }}</option>
                      }
                    </select>
                    <i class="fas fa-chevron-down" aria-hidden="true"></i>
                  </div>
                  @if (showError('country' + p.id, 'required')) { <small class="pay-field__error">Nationality is required.</small> }
                </div>

                <div class="pay-field"
                  [class.pay-field--error]="hasError('month_of_birth' + p.id) || hasError('day_of_birth' + p.id) || hasError('year_of_birth' + p.id)">
                  <span class="pay-field__label" [id]="'dob' + p.id">Date of birth</span>
                  <div class="pay-dob" role="group" [attr.aria-labelledby]="'dob' + p.id">
                    <input class="pay-input" type="text" inputmode="numeric" maxlength="2" placeholder="DD" aria-label="Day"
                      [id]="'day_of_birth' + p.id" [attr.name]="'day_of_birth' + p.id" [formControlName]="'day_of_birth' + p.id">
                    <div class="pay-select">
                      <select class="pay-input" aria-label="Month" [id]="'month_of_birth' + p.id" [attr.name]="'month_of_birth' + p.id" [formControlName]="'month_of_birth' + p.id">
                        <option value="">Month</option>
                        @for (month of months; track month.value) {
                          <option [value]="month.value">{{ month.label }}</option>
                        }
                      </select>
                      <i class="fas fa-chevron-down" aria-hidden="true"></i>
                    </div>
                    <input class="pay-input" type="text" inputmode="numeric" maxlength="4" placeholder="YYYY" aria-label="Year"
                      [id]="'year_of_birth' + p.id" [attr.name]="'year_of_birth' + p.id" [formControlName]="'year_of_birth' + p.id">
                  </div>
                  @if (dobError(p.id); as message) { <small class="pay-field__error">{{ message }}</small> }
                </div>

                <div class="pay-field" [class.pay-field--error]="hasError('gender' + p.id)">
                  <label class="pay-field__label" [attr.for]="'gender' + p.id">Gender</label>
                  <div class="pay-select">
                    <select class="pay-input" [id]="'gender' + p.id" [attr.name]="'gender' + p.id" [formControlName]="'gender' + p.id">
                      <option value="">Select gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                    <i class="fas fa-chevron-down" aria-hidden="true"></i>
                  </div>
                  @if (showError('gender' + p.id, 'required')) { <small class="pay-field__error">Gender is required.</small> }
                </div>
              </div>

              @if (p.primary) {
                <div class="pay-contact">
                  <h3 class="pay-contact__title"><i class="far fa-envelope" aria-hidden="true"></i> Contact details</h3>
                  <p class="pay-contact__sub">We send your ticket and booking updates here.</p>
                  <div class="pay-grid">
                    <div class="pay-field" [class.pay-field--error]="hasError('email' + p.id)">
                      <label class="pay-field__label" [attr.for]="'email' + p.id">Email</label>
                      <input class="pay-input" type="email" autocomplete="email" placeholder="name@example.com"
                        [id]="'email' + p.id" [attr.name]="'email' + p.id" [formControlName]="'email' + p.id">
                      @if (showError('email' + p.id, 'required')) { <small class="pay-field__error">Email is required.</small> }
                      @if (showError('email' + p.id, 'email')) { <small class="pay-field__error">Enter a valid email address.</small> }
                    </div>
                    <div class="pay-field" [class.pay-field--error]="hasError('phoneno' + p.id)">
                      <label class="pay-field__label" [attr.for]="'phoneno' + p.id">Phone number</label>
                      <input class="pay-input" type="tel" autocomplete="tel" placeholder="e.g. 0712345678"
                        [id]="'phoneno' + p.id" [attr.name]="'phoneno' + p.id" [formControlName]="'phoneno' + p.id">
                      @if (showError('phoneno' + p.id, 'minlength')) { <small class="pay-field__error">Phone number should be 10 digits.</small> }
                      @if (showError('phoneno' + p.id, 'required')) { <small class="pay-field__error">Phone number is required.</small> }
                      @if (showError('phoneno' + p.id, 'pattern')) { <small class="pay-field__error">Enter a valid phone number.</small> }
                    </div>
                  </div>
                </div>
              }

              @if (passengerForms.length > 1) {
                <div class="pay-traveller__foot">
                  @if (!p.primary && canCopyNationality(p)) {
                    <button type="button" class="pay-link" (click)="copyNationality(p)">
                      <i class="far fa-copy" aria-hidden="true"></i>
                      Same nationality as Adult 1
                    </button>
                  }
                  <button type="button" class="pay-btn pay-btn--soft" (click)="saveTraveller(p)">
                    {{ p.position < passengerForms.length ? 'Save and continue' : 'Save traveller' }}
                    <i class="fas fa-arrow-right" aria-hidden="true"></i>
                  </button>
                </div>
              }
              }
            </section>
          }

          <!-- Payment method choice. Written once and shown in two places: inside the fare
               summary right above Pay now on desktop, and in this column on phones and tablets.
               Declared inside the form so the Airtel number stays part of it wherever it renders. -->
          <ng-template #payMethodBody let-suffix="suffix">
            <div class="pay-methods" role="radiogroup" aria-label="Payment method">
              @for (paymentOption of availablePaymentOptions; track paymentOption.value) {
                <label class="pay-method" [class.pay-method--active]="selectedPaymentMethod === paymentOption.value">
                  <input
                    type="radio"
                    class="pay-method__input"
                    [attr.name]="'paymentMethod' + suffix"
                    [value]="paymentOption.value"
                    [checked]="selectedPaymentMethod === paymentOption.value"
                    (change)="setPaymentMethod(paymentOption.value); revealPayButton()" />
                  <span class="pay-method__radio" aria-hidden="true"></span>
                  <span class="pay-method__label">{{ paymentOption.label }}</span>
                  @if (paymentOption.logo) {
                    <img [src]="paymentOption.logo" [alt]="paymentOption.label + ' logo'" class="pay-method__logo" />
                  }
                </label>
              }
            </div>

            @if (isAirtelPaymentSelected()) {
              <div class="pay-method-panel">
                <div class="pay-field" [class.pay-field--error]="airtelPhoneControl?.touched && airtelPhoneControl?.invalid">
                  <label class="pay-field__label" [attr.for]="'airtelPhone' + suffix">Airtel Money number</label>
                  <input [id]="'airtelPhone' + suffix" type="tel" class="pay-input" formControlName="airtelPhone" placeholder="e.g. 0734123456 or 0101123456" />
                  @if (airtelPhoneControl?.touched && airtelPhoneControl?.hasError('required')) {
                    <small class="pay-field__error">Enter the Airtel Money number you want to pay with.</small>
                  }
                  @if (airtelPhoneControl?.touched && airtelPhoneControl?.hasError('pattern')) {
                    <small class="pay-field__error">Enter a valid Airtel Kenya number, for example 0734..., 075..., 078... or 0101...</small>
                  }
                </div>
                <p class="pay-method-panel__note">
                  <i class="fas fa-info-circle" aria-hidden="true"></i>
                  We send the payment prompt to this number. Use an Airtel line that is active and enabled for Airtel Money.
                </p>
              </div>
            }
          </ng-template>

          <!-- Payment (phones and tablets; desktop shows it in the fare summary) -->
          <section class="pay-card pay-methods-card" aria-label="Payment method">
            <header class="pay-card__head">
              <div>
                <h2 class="pay-card__title">Payment method</h2>
                <p class="pay-card__sub"><i class="fas fa-lock" aria-hidden="true"></i> Payments are encrypted and processed securely.</p>
              </div>
            </header>

            <ng-container *ngTemplateOutlet="payMethodBody; context: { suffix: '' }"></ng-container>

            @if (promoRevealed && promoDiscountData) {
              <div class="pay-promo">
                <span class="pay-promo__badge"><i class="fas fa-tag" aria-hidden="true"></i> {{ promoDiscountData.code }} &middot; {{ getPromoDiscountPercent() }}% off</span>
                <span class="pay-promo__prices">
                  <span class="pay-promo__old">{{ bookingData?.total_currency }} {{ bookingData?.total_amount | number:'1.0-0' }}</span>
                  <span class="pay-promo__new">{{ bookingData?.total_currency }} {{ getPromoFinalAmount() | number:'1.0-0' }}</span>
                </span>
                <span class="pay-promo__save">You save {{ promoDiscountData.user.currency }} {{ promoDiscountData.user.amount | number:'1.0-0' }}</span>
              </div>
            }
          </section>

          <!-- Pay: shown here on phones and tablets; desktop uses the summary rail -->
          <div class="pay-submit pay-submit--inline">
            <div class="pay-submit__total">
              <span class="pay-submit__label">Total</span>
              <span class="pay-submit__amount">
                {{ bookingData.total_currency }}
                {{ (promoRevealed && promoDiscountData ? getPromoFinalAmount() : bookingData.total_amount) | number:'1.0-0' }}
              </span>
            </div>
            <button
              type="submit"
              class="pay-btn"
              [disabled]="loading"
              (click)="submitForm()">
              @if (loading) {
                <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                <span>Processing</span>
              } @else {
                <i class="fas fa-lock" aria-hidden="true"></i>
                <span>{{ hasPromoOffer && !promoRevealed ? 'Reveal offer and pay' : 'Pay now' }}</span>
              }
            </button>
          </div>
        </form>
      </div>

      <!-- Fare summary rail -->
      <aside class="pay-rail" aria-label="Fare summary">
        <div class="pay-rail__sticky">
          @if (!isExpired) {
            <div class="pay-timer" [class.pay-timer--urgent]="minutes < 5" role="timer">
              <i class="far fa-clock" aria-hidden="true"></i>
              <span>Price held for</span>
              <b>{{ minutes | number: '2.0' }}:{{ seconds | number: '2.0' }}</b>
            </div>
          }

          <section class="pay-card pay-summary">
            <h2 class="pay-card__title">Fare summary</h2>

            <div class="pay-summary__trip">
              <span class="pay-summary__route">
                {{ bookingData.slices[0].origin.iata_code }}
                <i class="fas" [class.fa-exchange-alt]="bookingData.slices.length > 1" [class.fa-long-arrow-alt-right]="bookingData.slices.length <= 1" aria-hidden="true"></i>
                {{ bookingData.slices[0].destination.iata_code }}
              </span>
              <span class="pay-summary__dates">
                {{ bookingData.slices[0].segments[0].departing_at.split("T")[0] | date:'EEE, d MMM' }}
                @if (bookingData.slices.length > 1) {
                  &ndash; {{ bookingData.slices[1].segments[0].departing_at.split("T")[0] | date:'EEE, d MMM' }}
                }
              </span>
            </div>

            <ul class="pay-summary__list">
              <li>
                <span>Economy &middot; {{ travellerSummary }}</span>
                <b>{{ bookingData.total_currency }} {{ bookingData.total_amount | number:'1.0-0' }}</b>
              </li>
              @if (promoRevealed && promoDiscountData) {
                <li class="pay-summary__discount">
                  <span><i class="fas fa-tag" aria-hidden="true"></i> Promo {{ promoDiscountData.code }} ({{ getPromoDiscountPercent() }}% off)</span>
                  <b>- {{ promoDiscountData.user.currency }} {{ promoDiscountData.user.amount | number:'1.0-0' }}</b>
                </li>
              }
            </ul>

            <div class="pay-summary__total">
              <span>Total</span>
              <b>
                {{ bookingData.total_currency }}
                {{ (promoRevealed && promoDiscountData ? getPromoFinalAmount() : bookingData.total_amount) | number:'1.0-0' }}
              </b>
            </div>
            <p class="pay-summary__note">Includes taxes and fees.</p>

            <!-- Payment method, right above the Pay button (desktop) -->
            <div class="pay-summary__methods">
              <h3 class="pay-summary__methods-title">
                <i class="fas fa-lock" aria-hidden="true"></i> Pay with
              </h3>
              <ng-container *ngTemplateOutlet="payMethodBody; context: { suffix: 'Rail' }"></ng-container>
            </div>

            <button
              type="submit"
              form="ngFormPayment"
              class="pay-btn pay-btn--block"
              [disabled]="loading"
              (click)="submitForm()">
              @if (loading) {
                <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                <span>Processing</span>
              } @else {
                <i class="fas fa-lock" aria-hidden="true"></i>
                <span>{{ hasPromoOffer && !promoRevealed ? 'Reveal offer and pay' : 'Pay now' }}</span>
              }
            </button>
            @if (remainingMissingFields > 0) {
              <p class="pay-summary__hint pay-summary__hint--error" role="alert">
                <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                {{ remainingMissingFields }} {{ remainingMissingFields === 1 ? 'field needs' : 'fields need' }} your attention.
              </p>
            }
            <p class="pay-summary__terms">
              By paying, you agree to our terms and conditions and money-back guarantee.
            </p>
          </section>

          <div class="pay-trust">
            <span><i class="fas fa-shield-alt" aria-hidden="true"></i> Secure payment</span>
            <span><i class="fas fa-headset" aria-hidden="true"></i> Support 8am to 10pm</span>
          </div>
        </div>
      </aside>
    </div>
  </div>
</main>

<button type="button" id="sessionExpired" class="btn" style="display:none;" data-toggle="modal" data-target="#expiredModal"></button>

                              <!-- Bootstrap Modal for Expiration -->
                              <div id="expiredModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLabel">
                                <div class="modal-dialog" role="document">
                                  <div class="modal-content">
                                    <div class="modal-header">
                                      <button id="dismissModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                      <h4 class="modal-title" id="modalLabel">Booking Expired</h4>
                                    </div>
                                    <div class="modal-body">
                                      <p>Your booking session has expired. Please try again or refresh the page to start over.</p>
                                    </div>
                                    <div class="modal-footer">
                                      <button type="button" class="btn btn-secondary" (click)="cancelModal()" data-dismiss="modal">Cancel</button>
                                      <button type="button" class="btn btn-primary" (click)="closePopup()">Refresh</button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <button type="button" id="priceMismatchBtn" class="btn" style="display:none;" data-toggle="modal" data-target="#priceMismatchModal"></button>

                              <!-- Price Mismatch Modal -->
                              <div id="priceMismatchModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="priceMismatchModalLabel">
                                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 460px;">
                                  <div class="modal-content" style="border-radius: 16px; border: none; box-shadow: 0 20px 60px rgba(0,0,0,0.18); overflow: hidden;">
                                    <!-- Header banner -->
                                    <div style="background: linear-gradient(135deg, #e85d04, #f48c06); padding: 28px 30px 20px; position: relative;">
                                      <button type="button" id="dismissPriceModal" class="close" data-dismiss="modal" aria-label="Close"
                                        style="position: absolute; top: 14px; right: 18px; color: white; opacity: 0.85; font-size: 22px; text-shadow: none;">
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                      <div style="display: flex; align-items: center; gap: 14px;">
                                        <div style="width: 52px; height: 52px; background: rgba(255,255,255,0.2); border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                                          <i class="fa fa-exclamation-triangle" style="color: white; font-size: 22px;"></i>
                                        </div>
                                        <div>
                                          <h4 style="color: white; margin: 0; font-weight: 700; font-size: 18px; line-height: 1.3;">Price Update</h4>
                                          <p style="color: rgba(255,255,255,0.85); margin: 4px 0 0; font-size: 13px;">The airline has revised this fare</p>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="modal-body" style="padding: 28px 30px 10px;">
                                      <!-- Price comparison -->
                                      <div style="background: #f8f9fa; border-radius: 12px; padding: 20px; margin-bottom: 20px;">
                                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                                          <span style="color: #888; font-size: 14px;">Original price</span>
                                          <span style="color: #999; font-size: 16px; text-decoration: line-through;">KES {{ priceMismatchData?.old | number:'1.0-0' }}</span>
                                        </div>
                                        <div style="display: flex; justify-content: space-between; align-items: center; padding-top: 12px; border-top: 1px dashed #ddd;">
                                          <span style="color: #333; font-weight: 600; font-size: 14px;">New price</span>
                                          <span [style.color]="priceMismatchData?.new > priceMismatchData?.old ? '#e85d04' : '#28a745'" style="font-size: 22px; font-weight: 700;">
                                            KES {{ priceMismatchData?.new | number:'1.0-0' }}
                                          </span>
                                        </div>
                                      </div>

                                      <!-- Difference badge -->
                                      <div style="text-align: center; margin-bottom: 8px;">
                                        <span [style.background]="priceMismatchData?.new > priceMismatchData?.old ? '#fff0e6' : '#e8f5e9'"
                                          [style.color]="priceMismatchData?.new > priceMismatchData?.old ? '#e85d04' : '#28a745'"
                                          style="display: inline-block; padding: 6px 18px; border-radius: 20px; font-size: 14px; font-weight: 600;">
                                          <i [class]="priceMismatchData?.new > priceMismatchData?.old ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                                          &nbsp;KES {{ (priceMismatchData?.new > priceMismatchData?.old ? priceMismatchData?.new - priceMismatchData?.old : priceMismatchData?.old - priceMismatchData?.new) | number:'1.0-0' }}
                                          {{ priceMismatchData?.new > priceMismatchData?.old ? 'increase' : 'decrease' }}
                                        </span>
                                      </div>

                                      <p style="color: #666; font-size: 13px; text-align: center; line-height: 1.5; margin-top: 14px;">
                                        Would you like to continue with the updated fare?
                                      </p>
                                    </div>

                                    <div class="modal-footer" style="border-top: none; padding: 10px 30px 28px; display: flex; gap: 12px;">
                                      <button type="button" class="btn" (click)="rejectPriceChange()"
                                        style="flex: 1; background: #f0f0f0; color: #555; border: none; border-radius: 10px; padding: 12px 0; font-weight: 600; font-size: 14px;">
                                        Go Back
                                      </button>
                                      <button type="button" class="btn" (click)="acceptPriceChange()"
                                        style="flex: 1.5; background: linear-gradient(135deg, #e85d04, #f48c06); color: white; border: none; border-radius: 10px; padding: 12px 0; font-weight: 700; font-size: 14px; box-shadow: 0 4px 12px rgba(232,93,4,0.35);">
                                        Accept &amp; Continue
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Promo Discount Trigger -->
                              <button type="button" id="promoDiscountBtn" class="btn" style="display:none;" data-toggle="modal" data-target="#promoDiscountModal"></button>

                              <!-- Promo Discount Modal -->
                              <div id="promoDiscountModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="promoDiscountModalLabel" data-backdrop="false">
                                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 680px; transition: transform 0.35s cubic-bezier(0.32, 0.72, 0, 1);">
                                  <!-- overflow:visible so the top badge can bleed outside the card -->
                                  <div class="modal-content" style="border-radius: 20px; border: none; box-shadow: 0 20px 60px rgba(0,0,0,0.18); overflow: visible; background: #fff; position: relative;">

                                    <!-- Close button -->
                                    <button type="button" id="dismissPromoModal" class="close" data-dismiss="modal" aria-label="Close"
                                      style="position: absolute; top: 14px; right: 18px; color: #999; opacity: 1; font-size: 22px; text-shadow: none; line-height: 1; z-index: 20; background: none; border: none;">
                                      <span aria-hidden="true">&times;</span>
                                    </button>

                                    <!-- Top-left deal badge — overflows the card top edge -->
      <div style="position: absolute; top: -15px; left: 20px; z-index: 10;
                  background: #1a7a3c; color: #fff; font-weight: 800; font-size: 13px;
                  padding: 7px 16px; border-radius: 8px; letter-spacing: 1px;
                  text-transform: uppercase; display: flex; align-items: center; gap: 8px;
                  box-shadow: 0 4px 12px rgba(26,122,60,0.35);">
                                      {{ promoDiscountData?.code }} &bull; {{ getPromoDiscountPercent() }}% OFF
                                      <span style="font-size: 16px; color: #ffe566; line-height: 1;">✦</span>
                                    </div>

                                    <!-- Decorative wave — top-right corner -->
                                    <div style="position: absolute; top: 0; right: 0; width: 200px; height: 70px; border-radius: 0 20px 0 0; overflow: hidden; pointer-events: none;">
                                      <svg viewBox="0 0 200 70" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:100%; height:100%;">
                                        <defs>
                                          <linearGradient id="pg" x1="0" y1="0" x2="1" y2="1">
                                            <stop offset="0%" stop-color="#1a7a3c" stop-opacity="0.18"/>
                                            <stop offset="100%" stop-color="#c8e63c" stop-opacity="0.22"/>
                                          </linearGradient>
                                        </defs>
                                        <path d="M200 0 L200 70 L80 70 Q140 40 100 0 Z" fill="url(#pg)"/>
                                        <path d="M200 0 L130 0 Q170 30 110 70 L200 70 Z" fill="url(#pg)" opacity="0.5"/>
                                      </svg>
                                    </div>

                                    <!-- Card body: two columns -->
                                    <div style="padding: 34px 24px 20px; display: flex; align-items: flex-start; gap: 16px; flex-wrap: wrap;">

                                      <!-- LEFT: flight info -->
                                      <div style="flex: 1; min-width: 200px;">

                                        <!-- Airline logo + name -->
                                        <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 6px;">
                                          @if (bookingData?.slices?.[0]?.segments?.[0]?.marketing_carrier?.logo) {
                                            <img
                                              [src]="carrierLogoService.getCarrierLogo(bookingData?.slices?.[0]?.segments?.[0]?.marketing_carrier)"
                                              style="height: 38px; width: 38px; border-radius: 50%; object-fit: contain; border: 1px solid #eee; flex-shrink: 0;"
                                              alt=""
                                              (error)="carrierLogoService.setLogoPlaceholder($event)">
                                          }
                                          <span style="font-weight: 800; font-size: 19px; color: #111; line-height: 1.2;">
                                            {{ bookingData?.slices?.[0]?.segments?.[0]?.marketing_carrier?.name }}
                                          </span>
                                        </div>

                                        <!-- Route: City → City -->
                                        <div style="font-size: 15px; color: #555; font-weight: 500; margin-bottom: 10px;">
                                          {{ bookingData?.slices?.[0]?.origin?.city_name }} &rarr; {{ bookingData?.slices?.[0]?.destination?.city_name }}
                                        </div>

                                        <!-- Time · Duration · Direct pill -->
                                        <div style="display: flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 600; color: #222; flex-wrap: wrap; margin-bottom: 14px;">
                                          <i class="fa fa-clock-o" style="color: #666; font-size: 13px;"></i>
                                          <span>
                                            {{ bookingData?.slices?.[0]?.segments?.[0]?.departing_at?.split('T')[1] | timeFormart }}
                                            &ndash;
                                            {{ bookingData?.slices?.[0]?.segments?.[0]?.arriving_at?.split('T')[1] | timeFormart }}
                                          </span>
                                          <span style="color: #ccc;">&bull;</span>
                                          <i class="fa fa-plane" style="color: #555; font-size: 11px;"></i>
                                          <span>{{ bookingData?.slices?.[0]?.segments?.[0]?.duration | duration }}</span>
                                          @if (bookingData?.slices?.[0]?.stops) {
                                            <span style="color: #ccc;">&bull;</span>
                                          }
                                          @if (bookingData?.slices?.[0]?.stops) {
                                            <span style="background: #e8f5ee; color: #1a7a3c; padding: 2px 10px; border-radius: 20px; font-size: 12px; font-weight: 700;">
                                              {{ bookingData?.slices?.[0]?.stops }} {{ bookingData?.slices?.[0]?.stops === 1 ? 'stop' : 'stops' }}
                                            </span>
                                          }
                                        </div>

                                        <!-- Baggage row -->
                                        <div style="display: flex; align-items: center; gap: 14px; font-size: 13px; color: #777;">
                                          @if (bookingData?.slices?.[0]?.segments?.[0]?.passengers?.[0]?.baggages?.length) {
                                            @for (bg of bookingData.slices[0].segments[0].passengers[0].baggages; track bg) {
                                              @if (bg.type === 'checked') {
                                                <span style="display: flex; align-items: center; gap: 5px;">
                                                  <i class="fa fa-suitcase" style="font-size: 13px;"></i> Free bag included
                                                </span>
                                              }
                                            }
                                          }
                                        </div>

                                      </div>

                                      <!-- RIGHT: pricing -->
                                      <div style="text-align: right; flex-shrink: 0;">

                                        <!-- Original price strikethrough -->
                                        <div style="color: #aaa; font-size: 14px; text-decoration: line-through; margin-bottom: 0px;">
                                          {{ bookingData?.total_currency }} {{ bookingData?.total_amount | number:'1.0-0' }}
                                        </div>

                                        <!-- Final price — large green -->
                                        <div style="line-height: 1; margin-bottom: 10px;">
                                          <span style="font-size: 13px; font-weight: 700; color: #1a7a3c; vertical-align: top; margin-top: 6px; display: inline-block;">
                                            {{ bookingData?.total_currency }}
                                          </span>
                                          <span style="font-size: 38px; font-weight: 800; color: #1a7a3c; letter-spacing: -1.5px;">
                                            {{ getPromoFinalAmount() | number:'1.0-0' }}
                                          </span>
                                        </div>

                                        <!-- Save badge -->
          <div style="background: #fff8e0; border: 1px solid #f0d060; border-radius: 20px;
                      padding: 4px 14px; font-size: 13px; font-weight: 700; color: #7a5800;
                      display: inline-block; margin-bottom: 8px;">
                                          Save {{ promoDiscountData?.user?.currency }} {{ promoDiscountData?.user?.amount | number:'1.0-0' }}
                                        </div>

                                      </div>
                                    </div>

                                    <!-- Pay Now button -->
                                    <div style="padding: 0 24px 26px;">
                                      <button type="button" class="btn" (click)="confirmPromoAndPay()"
          style="width: 100%; background: #c62828; color: #fff; border: none; border-radius: 50px;
                 padding: 15px 0; font-size: 16px; font-weight: 700;
                 display: flex; align-items: center; justify-content: center; gap: 10px;
                 box-shadow: 0 4px 18px rgba(198,40,40,0.35);">
                                        @if (isProcessingPayment) {
                                          <img src="assets/img/gifs/76.gif" alt="Loading" style="height: 22px;">
                                        }
                                        @if (!isProcessingPayment) {
                                          Pay Now &nbsp;<i class="fa fa-chevron-right"></i>
                                        }
                                      </button>
                                    </div>

                                  </div>
                                </div>
                              </div>

                              <button type="button" id="bookingErrorhBtn" class="btn" style="display:none;" data-toggle="modal" data-target="#bookingErrorModal"></button>


                              <!-- Booking Error Modal -->
                              <div id="bookingErrorModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="bookingErrorModalLabel">
                                <div class="modal-dialog" role="document" style="max-width: 500px;">
                                  <div class="modal-content" style="border-radius: 12px; border: none; box-shadow: 0 10px 30px rgba(0,0,0,0.2);">
                                    <div class="modal-header" style="border-bottom: none; padding: 30px 30px 10px 30px; text-align: center;">
                                      <button type="button" id="dismissErrorModal" class="close" data-dismiss="modal" aria-label="Close" style="position: absolute; top: 15px; right: 20px; font-size: 24px; opacity: 0.5;">
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                    <div class="modal-body text-center" style="padding: 0 30px 20px 30px;">
                                      <!-- Error icon -->
                                      <div style="margin-bottom: 20px;">
                                        <div style="width: 80px; height: 80px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto; background-color: rgba(220, 53, 69, 0.1);">
                                          <i [class]="'fa ' + currentError?.icon" [style.color]="currentError?.iconColor" style="font-size: 32px;"></i>
                                        </div>
                                      </div>

                                      <h4 style="color: #333; margin-bottom: 15px; font-weight: 600; font-size: 22px;">
                                        {{currentError?.title}}
                                      </h4>

                                      <p style="color: #666; margin-bottom: 30px; line-height: 1.6; font-size: 16px;">
                                        {{currentError?.message}}
                                      </p>
                                    </div>
                                    <div class="modal-footer" style="border-top: 1px solid #eee; padding: 20px 30px; justify-content: space-between; background-color: #f8f9fa; border-radius: 0 0 12px 12px;">

                                      <button
                                        type="button"
                                        class="btn btn-primary"
                                        (click)="handleErrorPrimaryAction()"
                                        [style.background]="currentError?.primaryActionColor"
                                        style="border: none; border-radius: 6px; padding: 10px 25px; font-weight: 500; min-width: 120px;">
                                        {{currentError?.primaryAction}}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Payment Processing Overlay -->
                              @if (isProcessingPayment) {
                                <div
                                  style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(10,15,40,0.72); z-index: 9999; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(3px);">
                                  <div style="background: white; border-radius: 24px; padding: 44px 40px; text-align: center; max-width: 360px; width: 90%; box-shadow: 0 32px 80px rgba(0,0,0,0.3);">
                                    <!-- Spinner ring + lock icon -->
                                    <div style="position: relative; width: 80px; height: 80px; margin: 0 auto 28px;">
                                      <svg class="pay-spinner" style="width: 80px; height: 80px;" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="40" cy="40" r="34" stroke="#f0f4ff" stroke-width="7"/>
                                        <path d="M40 6 A34 34 0 0 1 74 40" stroke="#CF2264" stroke-width="7" stroke-linecap="round"/>
                                      </svg>
                                      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); width: 40px; height: 40px; background: #fde8f1; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
                                        <i class="fa fa-lock" style="color: #CF2264; font-size: 16px;"></i>
                                      </div>
                                    </div>
                                    <h4 style="color: #111; font-weight: 700; font-size: 20px; margin: 0 0 8px;">Processing Payment</h4>
                                    <p style="color: #777; font-size: 14px; line-height: 1.7; margin: 0 0 24px;">Please wait while we securely process your payment. Do not close or refresh this page.</p>
                                    <div style="display: flex; justify-content: center; gap: 8px;">
                                      <span class="pay-dot" style="width: 9px; height: 9px; background: #CF2264; border-radius: 50; display: inline-block;"></span>
                                      <span class="pay-dot" style="width: 9px; height: 9px; background: #CF2264; border-radius: 50%; display: inline-block;"></span>
                                      <span class="pay-dot" style="width: 9px; height: 9px; background: #CF2264; border-radius: 50%; display: inline-block;"></span>
                                    </div>
                                  </div>
                                </div>
                              }

                              <!-- Payment Error trigger -->
                              <button type="button" id="paymentErrorBtn" class="btn" style="display:none;" data-toggle="modal" data-target="#paymentErrorModal"></button>

                              <!-- Payment Error Modal -->
                              <div id="paymentErrorModal" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 440px;">
                                  <div class="modal-content" style="border-radius: 16px; border: none; box-shadow: 0 20px 60px rgba(0,0,0,0.18); overflow: hidden;">
                                    <!-- Red header -->
                                    <div style="background: linear-gradient(135deg, #c62828, #e53935); padding: 28px 28px 20px; text-align: center;">
                                      <div style="width: 60px; height: 60px; background: rgba(255,255,255,0.15); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 14px;">
                                        <i class="fa fa-times-circle" style="color: white; font-size: 26px;"></i>
                                      </div>
                                      <h4 style="color: white; margin: 0; font-weight: 700; font-size: 19px;">{{ getPaymentErrorTitle() }}</h4>
                                    </div>

                                    <div class="modal-body" style="padding: 28px 28px 10px; text-align: center;">
                                      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 10px;">
                                        {{ paymentError }}
                                      </p>
                                      <div style="background: #f8f9fb; border: 1px solid #eceff3; border-radius: 12px; padding: 16px 18px; text-align: left; margin: 18px 0 12px;">
                                        <p style="color: #333; font-size: 13px; font-weight: 700; margin: 0 0 10px;">What to check</p>
                                        @for (tip of getPaymentErrorTips(); track tip) {
                                          <div style="display: flex; align-items: flex-start; gap: 10px; color: #555; font-size: 13px; line-height: 1.5; margin-bottom: 8px;">
                                            <i class="fa fa-check-circle" style="color: #1976d2; margin-top: 2px;"></i>
                                            <span>{{ tip }}</span>
                                          </div>
                                        }
                                      </div>
                                      <p style="color: #888; font-size: 13px; margin: 0;">Your booking is still reserved. You can retry the payment below.</p>
                                    </div>

                                    <div class="modal-footer" style="border-top: none; padding: 16px 28px 28px; display: flex; flex-direction: column; gap: 10px;">
                                      <button type="button" class="btn" (click)="retryPayment()"
                                        style="width: 100%; background: linear-gradient(135deg, #1565c0, #1976d2); color: white; border: none; border-radius: 10px; padding: 14px 0; font-size: 15px; font-weight: 700; box-shadow: 0 4px 14px rgba(21,101,192,0.3);">
                                        <i class="fa fa-redo"></i> &nbsp; Try Again
                                      </button>
                                      <button type="button" id="dismissPaymentErrorModal" class="btn" data-dismiss="modal"
                                        style="width: 100%; background: #f5f5f5; color: #555; border: none; border-radius: 10px; padding: 12px 0; font-size: 14px; font-weight: 500;">
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <app-footer></app-footer>
